import { ChangeDetectorRef, Component } from '@angular/core';
import { TokenService } from '@shared/services/token.service';
import { subMenuItems } from '../../submenu';
import { ApiService } from '@shared/services/api.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { UtilsService } from '@shared/services/utils.service';
import { MessageService } from 'primeng/api';
import { Validators } from '@angular/forms';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PaymentsMenuService } from '@shared/services/payments-menu.service';
import { catchError, of } from 'rxjs';

@Component({
  selector: 'app-create',
  templateUrl: './create.component.html',
  styleUrls: ['./create.component.scss']
})
export class CreateComponent {
  public subMenuItems: any = [];
  public invoiceNumber: string = 'Por crear';
  public invoice: any = {};
  public invoiceDetails: any[] = [];
  public invoiceDetailsCounter: number = 0;
  public time: any = null;
  public statusText: string = '';
  public formCustomer!: FormGroup;
  public formAddressCustomer!: FormGroup;
  public selectedCustomer: any = null;
  public results: any[] = [];
  public submitAttemptedCustomer: boolean = false;
  public totals: any = {
    totalBase: 0,
    totalTaxes: 0,
    totalEur: 0
  }
  public setting: any = {};
  public selectedAddress: any = null;
  public warningMessage!: string;
  public formSteps: { [key: string]: boolean } = {
    'serviceDataForm': false,
    'customerDataForm': false,
    'addressCustomerForm': false,
  }
  public transactionModalVisible: boolean = false;
  public newTicketId: number | null = null;
  public transactionForms: FormGroup[] = [];
  public transactions: any[] = [];
  public isTransactionsValid: boolean = false;
  public isButtonSaveInvoiceDisabled: boolean = false;

  constructor(
    public apiService: ApiService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public messageService: MessageService,
    public utils: UtilsService,
    private cdr: ChangeDetectorRef,
    private tokenService: TokenService,
    private formBuilder: FormBuilder,
    private subMenuService: PaymentsMenuService
  ) { }

  ngOnInit() {
    this.subMenuItems = this.subMenuService.getSubMenuItems();
    this.formCustomer = this.formBuilder.group({
      name: ['', [Validators.required]],
      cif: [''],
      phone: [''],
      email: ['', [Validators.email]],
    });
    this.formAddressCustomer = this.formBuilder.group({
      street_name: ['', [Validators.required]],
      street_number: ['', [Validators.required]],
      floor: [''],
      description: [''],
      city: ['', [Validators.required]],
      province: [''],
      country: ['', [Validators.required]],
      postal_code: ['', [Validators.required, Validators.pattern('^[a-zA-Z0-9\\s\\-]{5,}$')]]
    });
    this.apiService.getSettings().subscribe((response: any) => {
      this.setting = response;
      this.createNewInvoiceDetail();
      console.log('setting: ', this.setting);
    })
    this.cdr.detectChanges();
    this.addTransactionForm();
  }

  ngAfterViewInit() {
    this.apiService.getSettings().subscribe((response: any) => {
      this.invoice.company_name = response.company_name;
      this.invoice.company_cif = response.cif;
      this.invoice.company_address = response.fiscal_address;
      this.invoice.company_email = response.admin_email;
    });


    this.cdr.detectChanges();
  }

  createNewInvoiceDetail() {
    this.invoiceDetailsCounter++;
    this.invoiceDetails.push({
      id: this.invoiceDetailsCounter,
      concept: 'Nuevo concepto',
      unit_price: '0.00',
      units: 0,
      total: '0.00',
      vat: '0',
      base_tax: 0,
      detail_subtotal: 0
    });
    console.log(this.invoiceDetails);
  }

  searchCustomer(event: any) {
    const query = event.query;
    if (query && query.length > 2) {
      this.apiService.getCustomersPaginated(query.toLowerCase()).subscribe((response: any) => {
        this.results = response;
      });
    } else {
      this.results = [];
    }
  }

  handleInputData(event: any, attribute: string, detailId: number) {

    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    const keyPressed = event.key;
    let inputValue = event.target.value;
    const inputElement = event.target;
    let selectionStartEarly = inputElement.selectionStart;

    if (attribute == 'units') {

      if (/\D/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
        event.target.value = '';
        event.preventDefault();
        return;
      }

      if (inputValue.trim() == '') {
        inputValue = '0';
        event.target.value = '0';
      }

      this.recalculateAll(inputValue, attribute, detailId, inputElement);
    } else if (attribute == 'vat') {

      if (/\D/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
        event.target.value = '';
        event.preventDefault();
        return;
      }

      if (inputValue.trim() == '') {
        inputValue = '0';
        event.target.value = '0';
      }

      this.recalculateAll(inputValue, attribute, detailId, inputElement);

    } else if (attribute == 'unit_price') {
      if (inputValue.trim() == '') {
        inputValue = '0';
      }
      this.recalculateAll(inputValue, attribute, detailId, inputElement);
    } else {
      this.recalculateAll(inputValue, attribute, detailId, inputElement);
    }
  }

  setInputToZero(event: any, attribute: string, detailId: number) {
    if (attribute == 'units' || attribute == 'unit_price' || attribute == 'vat') {
      let inputValue = (event.target?.value ?? event).toString();
      if (inputValue.trim() == '') {
        inputValue = '0';
        this.recalculateAll(inputValue, attribute, detailId);
      }
    }
  }

  recalculateAll(inputValue: any, attribute: string, detailId: number, inputElement?: any) {

    this.invoiceDetails = this.invoiceDetails.map((detail: any) => {
      if (detail.id == detailId) {
        detail['edited'] = true;
        let totalValue: any = 0;

        if (attribute == 'units') {
          detail['units'] = parseInt(inputValue, 10);
        } else if (attribute == 'vat') {
          detail['vat'] = parseInt(inputValue, 10);

        } else if (attribute == 'unit_price') {

          totalValue = parseFloat(inputValue);

          if (totalValue == 0) {
            detail['unit_price'] = '0';
          } else {
            detail['unit_price'] = totalValue;

          }

        } else if (attribute == 'concept') {

          detail['concept'] = inputValue.toString();

        }

        if (attribute == 'units' || attribute == 'unit_price' || attribute == 'vat') {
          if (detail['unit_price'] != 0) {
            detail['detail_subtotal'] = (detail['unit_price'] - (detail['unit_price'] * (detail['vat'] / 100))) * detail['units'];
            detail['base_tax'] = (parseFloat(detail['unit_price']) * detail['units']) - detail['detail_subtotal'];
          } else {
            detail['unit_price'] = 0;
            detail['detail_subtotal'] = 0;
            detail['base_tax'] = 0;
          }

          if (detail['unit_price'] == '0') {
            detail['unit_price'] = '0.00';
          } else {
            detail['unit_price'] = Number(detail['unit_price']).toFixed(2);
          }

          this.calculateTotals();
        }

      }
      return detail;
    });

  }

  calculateTotals() {
    this.totals['totalEur'] = 0;
    this.totals['totalTaxes'] = 0;
    this.totals['totalBase'] = 0;
    for (let detail of this.invoiceDetails) {
      if (detail['unit_price'] != 0) {
        this.totals['totalEur'] += detail['detail_subtotal'];
      }
    }
    this.totals['totalBase'] = Number(this.totals['totalEur']) / (1 + (Number(this.setting.tax) / 100));
    this.totals['totalTaxes'] = Number(this.totals['totalEur']) - this.totals['totalBase'];
  }

  onDeleteInvoiceDetail(detailId: number) {
    if (this.invoiceDetails.length > 1) {
      this.invoiceDetails = this.invoiceDetails.filter((detail: any) => {
        return (detail.id != detailId);
      });
    }
    this.calculateTotals();
  }

  validateOnlyFloat(event: any) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    const keyPressed = event.key;

    // Obtener el valor actual del input
    const currentValue = event.target.value;
    const hasMultipleDots = currentValue.split('.').length > 2;
    let hasErrorLessSign = false;
    if (keyPressed === '-') {
      console.log(event.target.selectionStart);
      if (event.target.selectionStart !== 1 && currentValue.includes('-')) {
        hasErrorLessSign = true;
      }
    } else if (currentValue.includes('-') && currentValue.indexOf('-') !== 0) {
      hasErrorLessSign = true;
    }
    console.log('hasErrorlesssign', hasErrorLessSign);
    if (
      (!/^\d$/.test(keyPressed) && keyPressed !== '.' && keyPressed !== '-' && !allowedKeys.includes(keyPressed)) ||
      hasMultipleDots || hasErrorLessSign
    ) {
      // Solo borra el campo si el carácter es completamente inválido (no números, punto adicional o signo negativo)
      event.target.value = '';
      event.preventDefault();
      return;
    }
  }

  onSelectCustomer(event: any) {
    this.selectedCustomer = event.value;
    this.formCustomer.patchValue({
      name: this.selectedCustomer.name,
      cif: this.selectedCustomer.cif,
      phone: this.selectedCustomer.phone,
      email: this.selectedCustomer.email
    });
  }

  isCustomerDataModified(data: any): boolean {
    return (
      data.name !== this.selectedCustomer.name ||
      data.cif !== this.selectedCustomer.cif ||
      data.phone !== this.selectedCustomer.phone ||
      data.email !== this.selectedCustomer.email
    );
  }

  saveCustomer() {
    if (this.formCustomer.valid) {
      this.submitAttemptedCustomer = false;
      const customerFormData = this.formCustomer.value;
      if (this.selectedCustomer) {
        if (this.isCustomerDataModified(customerFormData)) {
          this.updateCustomer(customerFormData);
        } else {
          this.toggleForm('customerDataForm');
        }
      } else {
        this.createCustomer(customerFormData);
      }
      this.invoice.customer_name = this.selectedCustomer?.name;
      this.invoice.customer_cif = this.selectedCustomer?.cif;
      this.invoice.customer_phone = this.selectedCustomer?.phone;
      this.invoice.customer_email = this.selectedCustomer?.email;
      // this.cdr.detectChanges();
    }
  }

  createCustomer(customerData: any) {
    this.apiService.post('/customer/create', customerData).subscribe(
      (response: any) => {
        this.selectedCustomer = response;
        this.selectedCustomer.addresses = [];
        this.toggleForm('customerDataForm')
      },
      (error) => {
        console.log('Error al crear cliente', error);
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  updateCustomer(customerData: any) {
    this.apiService.post(`/customer/update/${this.selectedCustomer.id}`, customerData).subscribe(
      (response: any) => {
        this.selectedCustomer = { ...this.selectedCustomer, ...customerData };
        this.toggleForm('customerDataForm');
      },
      (error) => {
        console.log('error actualizar cliente', error);
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  editAddress(address: any) {
    this.selectedAddress = address;
    this.formAddressCustomer.patchValue(address);
    this.toggleForm('addressCustomerForm');
  }

  deleteAddress(address: any) {
    if (this.selectedCustomer) {
      const addressToDelete = this.selectedCustomer.address;
      if (addressToDelete) {
        this.apiService.post(`/address/delete/${address.id}`, address).subscribe(
          (response: any) => {

          },
          (error) => {
            if (error && error.error && error.error.data) {
              this.handleValidationErrors(error.error.data);
            }
          }
        );
        this.selectedCustomer.address = null;
        this.selectedAddress = null;
      }
    }
  }

  saveAddressCustomer() {
    const addressNewData = this.formAddressCustomer.value;

    if (this.selectedCustomer) {
      if (this.selectedAddress) {
        const addressSearched = this.selectedCustomer.address;

        if (addressSearched) {
          this.updateAddress(this.selectedAddress);
        }

      } else {
        this.createAddress(addressNewData);
      }
      if (this.isFormValid(this.formAddressCustomer)) {
        this.formAddressCustomer.reset();
        this.toggleForm('addressCustomerForm');
      }


    } else {
      this.warningMessage = '¡Necesitas seleccionar un cliente!';
    }
  }

  isFormValid(form: FormGroup): boolean {
    return form.valid;
  }

  updateAddress(customerAddressData: any) {
    const addressId = customerAddressData.id;
    this.apiService.post(`/address/update/${addressId}`, this.formAddressCustomer.value).subscribe(
      (response: any) => {
        // const index = this.selectedCustomer.addresses.indexOf(this.selectedAddress);
        // if (index !== -1) {
        //   this.selectedCustomer.addresses[index] = response.address;
        //   this.selectedAddress = null;
        // }
        this.selectedCustomer.address = response.address;
        this.selectedAddress = null;
      },
      (error) => {
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  createAddress(customerAddressData: any) {
    this.apiService.post(`/address/create/${this.selectedCustomer.id}`, customerAddressData).subscribe(
      (response: any) => {
        this.selectedCustomer.address = response.address;

      },
      (error) => {
        if (error && error.error && error.error.data) {
          this.handleValidationErrors(error.error.data);
        }
      }
    );
  }

  saveInvoice() {
    this.isButtonSaveInvoiceDisabled = true;
    // this.invoiceDetails = this.invoiceDetails.filter((detail: any) => Number(detail.detail_subtotal) > 0);
    if (this.invoiceDetails.length == 0) {
      this.createNewInvoiceDetail();
      this.messageService.add({ severity: 'error', summary: 'Factura', detail: 'Ingrese registros validos que el subtotal sea mayor a 0 euros.' });
      this.isButtonSaveInvoiceDisabled = false;
      return;
    }
    if (!this.invoice.customer_name || this.invoice.customer_name?.trim() == '') {
      this.messageService.add({ severity: 'error', summary: 'Factura', detail: 'Adjunte un cliente a la factura.' });
      this.isButtonSaveInvoiceDisabled = false;
      return;
    }
    this.invoiceDetails = this.invoiceDetails.map((detail: any) => {
      detail.total = (Number(detail.units) * Number(detail.unit_price));
      return detail;
    });
    this.invoice.customer_address = `${this.selectedCustomer.address?.street_name} ${this.selectedCustomer.address?.street_number} ${this.selectedCustomer.address?.floor} ${this.selectedCustomer.address?.description} ${this.selectedCustomer.address?.city} ${this.selectedCustomer.address?.province} ${this.selectedCustomer.address?.country} ${this.selectedCustomer.address?.postal_code}`;
    this.invoice.details = this.invoiceDetails
    this.invoice.total = this.invoiceDetails.reduce((total: number, detail: any) => {
      return total + (Number(detail.detail_subtotal));
    }, 0);

    if (!this.isTransactionsValid) {
      this.messageService.add({ severity: 'warning', summary: 'Transacciones', detail: 'Ingrese las transacciones correctamente.' });
      this.openTransactionModal();
      this.isButtonSaveInvoiceDisabled = false;
      return;
    }
    console.log('this.invoice', this.invoice);
    this.apiService.saveInvoice(this.invoice).subscribe({
      next: (response: any) => {
        console.log('invoice saved: ', response);
        let invoice = response;
        this.apiService.saveTicketFromInvoice(invoice).subscribe({
          next: (ticketResponse: any) => {
            this.messageService.add({ severity: 'success', summary: 'Factura', detail: 'Factura creada correctamente.' });
            this.newTicketId = ticketResponse.id;
            this.transactions = this.transactions.map((transaction: any) => {
              transaction.ticket_id = this.newTicketId;
              return transaction;
            });
            console.log('transactions: ', this.transactions);
            this.apiService.post('/cashier-entry/save-all', { cashier_entries: this.transactions })
              .subscribe({
                next: (response: any) => {
                  this.messageService.add({ severity: 'success', summary: 'Transacción', detail: 'Transacciones creadas correctamente.' });
                },
                error: (error) => {
                  console.log('Error al crear transacciones', error);
                  this.messageService.add({ severity: 'error', summary: 'Transacción', detail: 'Error al guardar las transacciones. La factura fue creada. Contacta con el administrador.' });
                  if (error && error.error && error.error.data) {
                    this.handleValidationErrors(error.error.data);
                  }
                },
                complete: () => {
                  this.resetInvoiceForm();
                  this.isButtonSaveInvoiceDisabled = false;
                }
              });
          },
          error: (error: any) => {
            console.log('Error al generar ticket desde factura', error);
            // La factura SÍ fue creada, avisamos al usuario
            this.messageService.add({
              severity: 'warn',
              summary: 'Factura creada',
              detail: 'La factura fue guardada en el sistema pero hubo un error al generar el ticket. Revisa la lista de facturas.',
              life: 10000
            });
            this.isButtonSaveInvoiceDisabled = false;
          }
        });
      },
      error: (error: any) => {
        console.log('Error al guardar factura', error);
        this.messageService.add({ severity: 'error', summary: 'Factura', detail: 'Error al guardar la factura. Inténtalo de nuevo.' });
        this.isButtonSaveInvoiceDisabled = false;
      }
    });

  }

  openTransactionModal() {
    this.transactionModalVisible = true;
  }

  addTransactionForm() {
    const transactionForm = this.formBuilder.group({
      payment_method: ['EFECTIVO', Validators.required],
      amount: ['', [Validators.required, Validators.pattern('^-?[0-9]+(\\.[0-9]{1,2})?$')]]
    });
    this.transactionForms.push(transactionForm);
  }

  removeTransactionForm(index: number) {
    if (this.transactionForms.length > 1) {
      this.transactionForms.splice(index, 1);
    }
  }

  getTotalTransactionAmount(): number {
    return this.transactionForms.reduce((total, form) => total + parseFloat(form.get('amount')?.value || '0'), 0);
  }

  saveTransactions() {
    this.isTransactionsValid = false;
    const transactions = this.transactionForms.map(form => {
      if (form.valid) {
        return {
          received: form.value.amount,
          ...form.value
        };
      }
      return null;
    }).filter(transaction => transaction !== null);

    if (this.getTotalTransactionAmount() > this.invoice.total) {
      this.messageService.add({ severity: 'error', summary: 'Transacción', detail: 'El monto total de las transacciones no puede superar el monto total de la factura.' });
      return;
    }
    this.isButtonSaveInvoiceDisabled = false;
    this.isTransactionsValid = true;
    console.log('transactions: ', transactions);
    this.transactions = transactions;

    this.transactionModalVisible = false;
  }

  handleValidationErrors(validationData: any) {
    Object.keys(validationData).forEach(key => {
      const errorMessages = validationData[key];
      const messageToast = ` ${errorMessages.join(", ")}`;
      this.messageService.add({ severity: 'error', summary: 'Error de validación', detail: messageToast, life: 30000 });
    });
  }

  toggleForm(section: string) {
    this.formSteps[section] = !this.formSteps[section];
  }

  resetInvoiceForm() {
    this.invoiceNumber = 'Por crear';
    this.invoice = {};
    this.invoiceDetails = [];
    this.createNewInvoiceDetail();
    this.invoiceDetailsCounter = 0;
    this.time = null;
    this.statusText = '';
    this.formCustomer.reset();
    this.formAddressCustomer.reset();
    this.selectedCustomer = null;
    this.results = [];
    this.submitAttemptedCustomer = false;
    this.totals = {
      totalBase: 0,
      totalTaxes: 0,
      totalEur: 0
    };
    this.setting = {};
    this.selectedAddress = null;
    this.warningMessage = '';
    this.formSteps = {
      'serviceDataForm': false,
      'customerDataForm': false,
      'addressCustomerForm': false,
    };
    this.transactionModalVisible = false;
    this.newTicketId = null;
    this.transactionForms = [];
    this.transactions = [];
    this.isTransactionsValid = false;
    this.addTransactionForm();
  }

}
